import { connect } from 'react-redux';
import TinyOvbRakeback from '../views/tiny/TinyOvbRakeback';

function mapStateToProps(state, ownProps) {
  return {};
}

const mapDispatchToProps = (dispatch, ownProps) => ({});

const TinyOvbRakebackContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(TinyOvbRakeback);

export default TinyOvbRakebackContainer;
